import { css, styled } from '@mui/material/styles';

import { lightGreyBoxShadow, rem, Theme } from '../../theme';
import { Heading } from '../Heading';

import { StyledTileProperties, StyledHeadingProperties } from './Tile.types';

const variants = {
    primary: (theme: Theme) => css`
        box-shadow: ${lightGreyBoxShadow};
    `,
    secondary: (theme: Theme) => css`
        background-color: ${theme.palette.grey[100]};
    `,
    borderBlue: (theme: Theme) => css`
        border: ${theme.tggSpacing(rem(0.2), 0.5)} solid
            ${theme.palette.common.blue};
    `,
} as const;

export const StyledTile = styled('div')<StyledTileProperties>`
    ${({
        $variant,
        theme,
    }: {
        $variant: keyof typeof variants;
        theme: Theme;
    }) => variants[$variant](theme)};
    ${({ theme, $gutterBottom }: { theme: Theme; $gutterBottom: boolean }) => `
        display: inline-block;
        width: 100%;
        margin-bottom: ${$gutterBottom && `${theme.tggSpacing(rem(3), 7.5)};`};
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${$gutterBottom && `${theme.tggSpacing(rem(4), 10)};`};
        }
        border-radius: ${theme.tggSpacing(rem(0.8), 2)};
        
    `}
`;

export const StyledHeadingContainer = styled('div')<StyledHeadingProperties>`
    ${({ theme, $color }: { theme: Theme; $color?: string }) => `
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${theme.tggSpacing([rem(2), rem(3)], [5, 7.5])};
        text-align: center;
        background-color: ${$color ?? theme.palette.common.white};
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([rem(3), rem(4)], [7.5, 10])};
        }
    `}
`;

export const StyledHeading = styled(Heading, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledHeadingProperties>`
    color: ${({ $color, theme }) => $color ?? theme.palette.common.blue};
    text-transform: lowercase;
`;
